
        <div class="{{ getWrapperClasses() }}" [style.width]=" (handleWidth  + labelWidth ) +'px'">
            <div #container class="{{ baseClass }}-container"
                 [style.width]=" ((handleWidth * 2) + labelWidth) +'px'"
                 [style.margin-left]="getLabelMarginLeft()"><!--
                --><span #on [innerHTML]="(inverse) ? offText : onText" class="{{ (inverse) ? getOffClasses() : getOnClasses() }}"></span><!--
                --><span #label class="{{ baseClass }}-label">&nbsp;{{ labelText }}</span><!--
                --><span #off [innerHTML]="(inverse) ? onText : offText" class="{{ (inverse) ? getOnClasses() : getOffClasses() }}"></span><!--
                --><input type="checkbox" [(ngModel)]="value" [readonly]="readonly" [disabled]="disabled"
                       (focus)="onFocus()" (blur)="onBlur()">
            </div>
        </div>